export default __webpack_public_path__ + "static/media/fit.3bb22896.svg";